module.exports = require("styled-components");


//////////////////
// WEBPACK FOOTER
// external "styled-components"
// module id = 1
// module chunks = 0